// extracted by mini-css-extract-plugin
module.exports = {"tab":"SGSTab_tab__22BTT","selected":"SGSTab_selected__1VG4z","count":"SGSTab_count__2pqB5","wrapper":"SGSTab_wrapper__2kCLl"};